
import React from 'react';
import { media } from '../../server';
import { useStateContext } from '../../context/ContextProvider';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';

import {
  FiClock,

  FiStar,
  FiArrowLeft
} from 'react-icons/fi';

import {
  FaFireAlt
} from 'react-icons/fa';

function FeaturedMealsCard({ meals }) {

  const { currentDir } = useStateContext();
  const { t } = useTranslation();

  const preparationTime =
    meals?.preparationTime
      ? `${meals.preparationTime} ${t("minutes")}`
      : `20 ${t("minutes")}`;

  return (

    <motion.div
      whileHover={{ y: -12 }}
      transition={{ duration: 0.4 }}
      className="group relative overflow-hidden rounded-[2rem] h-[520px] shadow-2xl"
    >

      {/* Background Image */}
      <div className="absolute inset-0">

        <img
          src={`${media}${meals?.Image}`}
          alt={currentDir === "ltr" ? meals.titleEn : meals.titleAr}
          className="w-full h-full object-cover group-hover:scale-110 duration-700"
        />

        {/* Dark Overlay */}
        <div className="absolute inset-0 bg-gradient-to-t from-black via-black/50 to-black/10"></div>

      </div>

      {/* Category */}
      <div className="absolute top-5 left-5 z-20">

        <div className="backdrop-blur-xl bg-white/10 border border-white/20 text-white px-4 py-2 rounded-full flex items-center gap-2">

          <FaFireAlt className="text-color-1" />

          <span className="font-kufi text-sm">
            {currentDir === "ltr"
              ? meals.categoryId?.titleEn
              : meals.categoryId?.titleAr}
          </span>

        </div>

      </div>

      {/* Rating */}
      <div className="absolute top-5 right-5 z-20">

        <div className="bg-black/40 backdrop-blur-xl border border-white/10 text-white px-3 py-2 rounded-full flex items-center gap-2">

          <FiStar className="text-yellow-400 fill-yellow-400" />

          <span className="text-sm font-semibold">
            4.9
          </span>

        </div>

      </div>

      {/* Content */}
      <div className="absolute bottom-0 left-0 w-full z-20 p-6">

        <div className="backdrop-blur-2xl bg-white/10 border border-white/10 rounded-[2rem] p-6">

          {/* Title */}
          <h2 className="text-2xl md:text-3xl font-kufi text-white mb-3 line-clamp-1">

            {currentDir === "ltr"
              ? meals.titleEn
              : meals.titleAr}

          </h2>

          {/* Description */}
          <p className="text-white/80 body-3 leading-loose line-clamp-2 mb-5">

            {currentDir === "ltr"
              ? meals.descriptionEn
              : meals.descriptionAr}

          </p>

          {/* Bottom Row */}
          <div className="flex items-center justify-between gap-4 flex-wrap">

            {/* Price */}
            <div>

              {
                meals?.price ? (

                  <div className="flex items-end gap-2">

                    <span className="text-3xl font-bold text-color-1">
                      {meals.price}
                    </span>

                    <span className="text-white/80 font-kufi mb-1">
                      {t("currency")}
                    </span>

                  </div>

                ) : (

                  <span className="text-white/80 font-kufi">
                    {t("today price")}
                  </span>

                )
              }

            </div>

            {/* Time */}
            <div className="flex items-center gap-2 text-white/70">

              <FiClock />

              <span className="font-kufi text-sm">
                {preparationTime}
              </span>

            </div>

          </div>

          {/* CTA */}
          <Link
            to={`/FeaturedMealDetails/${meals._id}`}
            onClick={() => window.scrollTo(0, 0)}
          >

            <motion.div
              whileHover={{ scale: 1.03 }}
              whileTap={{ scale: 0.97 }}
              className="mt-6 w-full bg-color-1 hover:bg-color-3 duration-300 text-white rounded-2xl py-4 flex items-center justify-center gap-3 cursor-pointer"
            >

              <span className="font-kufi">
                {t("discover offer")}
              </span>

              <FiArrowLeft />

            </motion.div>

          </Link>

        </div>

      </div>

    </motion.div>
  );
}

export default FeaturedMealsCard;

